// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Deploy-time override so staging can point at its own Supabase project
// (test-mode Stripe keys / isolated DB) while production keeps the values
// below as fallback. Set VITE_SUPABASE_URL + VITE_SUPABASE_PUBLISHABLE_KEY
// in the staging deployment's environment; leave them unset on production.
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL || "https://qczblwoaiuxgesjzxjvu.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFjemJsd29haXV4Z2Vzanp4anZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2OTkzMDgsImV4cCI6MjA4ODI3NTMwOH0.8_WvREKiiHcwQ6wRrQRoDFSQEfGp8tnYtk3V4qdN2t8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

if (import.meta.env.DEV) {
  // @ts-ignore - dev-only debug handle
  window.supabase = supabase;
}